import React from 'react';
import CsvDownloader from 'react-csv-downloader';
import { isEmpty } from 'lodash';
import { postEvent } from '../../../api/tracking';
import styles from '../Dashboard.module.scss';
//tr
import { useTranslation } from 'react-i18next';
import { tr } from '../../../utils/translations/translator';
import { useAnalyticsHandlers } from '../../../analytics/__providers__/AnalyticsHandlersProvider';
interface CsvDownloaderHandlerProps {
  userId: any;
  properties: string;
  data: any;
  onDownload?: () => void;
  isLoading: boolean;
}

export const CsvDownloaderHandler: React.FC<CsvDownloaderHandlerProps> = ({
  userId,
  properties,
  data,
  onDownload,
  isLoading,
}) => {
  const { t } = useTranslation();
  const analytics = useAnalyticsHandlers();

  return (
    <div className={styles.CsvDownloader}>
      <CsvDownloader
        datas={data}
        filename={properties}
        disabled={isEmpty(data) || isLoading}
      >
        <button
          disabled={isEmpty(data) || isLoading}
          onClick={() => {
            postEvent('CSV_DOWNLOADED', userId, {
              additional_info: properties,
            });

            analytics?.client.Mixpanel.log('CSV_DOWNLOADED', [
              {
                url_domain: 'tipsterchat.com',
                url_page: window.location.href,
              },
            ]);
          }}
        >
          {tr(t, 'download')} csv
        </button>
      </CsvDownloader>
    </div>
  );
};
